import cookie from '../util/cookie';

function getFromQueryString( name ) {
  name = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );

  const regex = new RegExp( '[\\?&]' + name + '=([^&#]*)' );
  const results = regex.exec( location.search );

  return results === null ?
    '' : decodeURIComponent( results[ 1 ].replace( /\+/g, ' ' ) );
}

const keys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

const regEx = /starry.com/;
const hostname = window.location.hostname;
const domain = regEx.test( hostname ) ? '.starry.com' : false;
const expires = new Date( Date.now() + 1.21e+9 ); // 14 day expiration

keys.forEach( key => {
  const value = getFromQueryString( key );
  if ( value ) {
    cookie.setItem( key, value, expires, '/', domain );
  }
});

cookie.setItem(
  'last-href', window.location.href, expires, '/', '.starry.com'
);
